module.exports = __webpack_public_path__ + "static/img/37-3.2a06a13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/37-3.jpg
// module id = MywM
// module chunks = 0